import { AsyncPipe, NgIf } from '@angular/common';
import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogConfig, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { UnifiedTermsOfServiceAPIResponse, UnifiedTOSService } from '../../core/tos-unified.service';

interface DialogData {
  cancelText?: string;
  reloadTermsOfServiceData?: boolean;
}

@Component({
  imports: [MatDialogModule, TranslateModule, GalaxyPipesModule, AsyncPipe, MatButtonModule, NgIf],
  templateUrl: 'unified-tos-dialog.component.html',
  styleUrls: ['../dialog.component.scss', './unified-tos-dialog.component.scss'],
})
export class UnifiedTOSDialogComponent implements OnInit {
  unifiedTermsOfServiceData$: Observable<UnifiedTermsOfServiceAPIResponse>;
  loading$: Observable<boolean>;
  submitting = false;
  cancelText = 'TERMS_OF_SERVICE.LATER';

  constructor(
    @Inject(forwardRef(() => UnifiedTOSService))
    @Inject(MAT_DIALOG_DATA)
    private data: DialogData,
    public tosService: UnifiedTOSService,
    public dialogRef: MatDialogRef<UnifiedTOSDialogComponent>,
    private router: Router,
    private snackbarService: SnackbarService,
  ) {
    if (this.data?.cancelText) {
      this.cancelText = this.data.cancelText;
    }
  }

  static config(): MatDialogConfig {
    const conf = new MatDialogConfig();
    conf.autoFocus = false;
    conf.maxWidth = 800;
    return conf;
  }

  ngOnInit(): void {
    if (this.data?.reloadTermsOfServiceData) {
      this.tosService.reloadTermsOfServiceData();
    }
    this.unifiedTermsOfServiceData$ = this.tosService.unifiedTermsOfServiceData$;
    this.loading$ = this.tosService.tosDataLoaded$;
  }

  acceptTermsOfService(): void {
    this.submitting = true;
    this.tosService.acceptTermsOfService().subscribe(
      () => {
        this.submitting = false;
        this.tosService.hasAcceptedTOS = true;
        this.snackbarService.openSuccessSnack('Successfully accepted Terms of Service');
        this.closeDialog(true);
      },
      () => {
        this.submitting = false;
        this.snackbarService.openErrorSnack('Failed to accept Terms of Service');
      },
    );
  }

  closeDialog(accepted: boolean): void {
    this.dialogRef.close(accepted);
  }
}
